// This file serves as an entry point for the package
import { Tempus } from './src/tempus'
globalThis.Tempus = Tempus
